module.exports = __webpack_public_path__ + "static/media/Pouť-97-korunovace1b.ca1b0ae9.jpg";